import { MarkdownDoc } from '@/components/MarkdownDoc';
// Dokumentace žije v repozitáři (docs/VYROBA.md) — tady ji jen zobrazujeme,
// aby existoval jediný zdroj pravdy a nemuselo se to psát dvakrát.
import source from '../../../../docs/VYROBA.md?raw';

/** Dokumentace modulu Výroba — stejný text, jaký je v repozitáři. */
export function DokumentacePage() {
  return (
    <>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-text">Dokumentace</h1>
        <p className="text-sm text-text-secondary mt-0.5 max-w-2xl">
          Jak celý výrobní systém funguje — obrazovky, toky dat, automatiky a kam se kouknout, když
          něco nesedí.
        </p>
      </div>
      <div className="bg-surface rounded-xl shadow-card px-6 py-6">
        <MarkdownDoc source={source} />
      </div>
    </>
  );
}
